import React, { useState, useEffect } from "react";
import { Form, Formik, ErrorMessage } from "formik";
import TextInput from "../../components/TextInput";
import RadioInput from "../../components/RadioInput";
import NumberInput from "../../components/NumberInput";
import {
  Bullet,
  ButtonAtras,
  ButtonEnviar,
  ButtonNext,
  CheckIcon,
  CloseIcon,
  Div,
  DivButtons,
  DivContenedorError,
  DivContenedorMax,
  DivError,
  DivFlex,
  DivFlex2,
  DivFlex3,
  DivForm,
  DivNavbar,
  FieldP5,
  FieldPresupuesto,
  FormLabel,
  FormLabel3,
  FormSection,
  FormSection3,
  Label,
  ProgressBar,
  RadioGroup,
  RadioGroup3,
  RadioInput2,
  RadioInput3,
  RadioInputWrapper,
  SaveIcon,
  Step,
  StepProgress,
  Table,
  Table3,
  TextArea2,
  TextComment,
  WarningIcon,
  LabelRadio,
} from "./FormularioRevisionStyle";
import { Checkbox } from "primereact/checkbox";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Navbar from "../../components/Navbar";
import DocumentItem from "../../components/documentitem";
import Swal from "sweetalert2";
import {
  createComment,
  getComment,
  getSolicitudInfoById,
  getSolicitudById,
  fetchRespuestas,
  evaluarSolicitud,
  fetchPuntajes,
  fetchDocument,
} from "../../services/solicitud";
import CustomLoading from "../../components/Loading";

const MultiStepFormRevision = () => {
  const [checked, setChecked] = useState(false);

  const [currentStep, setCurrentStep] = React.useState(0);

  const [errores, setErrores] = useState([]);

  const [animating, setAnimating] = useState(false);
  const [solicitud, setSolicitud] = useState([]);
  const [user, setUser] = useState({});
  const [fecha, setFecha] = useState(0);
  const [solicitudDraft, setSolicitudDraft] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [respuestas, setRespuestas] = useState([]);
  const [puntajes, setPuntajes] = useState([]);
  const [solicitudId, setSolicitudId] = useState(0);

  const [presupuestos, setPresupuestos] = useState([]);
  const [presupuestoGO, setPresupuestosGO] = useState([]);
  const [presupuestoInfra, setPresupuestosInfra] = useState([]);
  const [presupuestoHhrr, setPresupuestosHhrr] = useState([]);
  const [radioSolucion1, setRadioSolucion1] = useState(null);
  const [radioSolucion2, setRadioSolucion2] = useState(null);
  const [radioSolucion3, setRadioSolucion3] = useState(null);
  const [radioSolucion4, setRadioSolucion4] = useState(null);
  const [radioSolucion5, setRadioSolucion5] = useState(null);
  const [radioSolucion6, setRadioSolucion6] = useState(null);
  const [radioSolucion7, setRadioSolucion7] = useState(null);

  const [comentarios, setComentarios] = useState([]);

  const [documentosSolicitud, setDocumentosSolicitud] = useState([]);
  const [stepValid, setStepValid] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const getCategoriasDocumentos = () => {
    return [
      {
        nombre: "Certificado de vigencia de la organización",
        id: "Certificado de vigen",
      },
      {
        nombre:
          "Cédula de identidad del representante legal de la organización",
        id: "Certificado de cedul",
      },
      {
        nombre: "Cédula de identidad de un integrante de la directiva",
        id: "Cedula directiva",
      },
      {
        nombre: "Cédula de identidad de otro integrante de la directiva",
        id: "Cedula directiva 2",
      },
      { nombre: "Cuenta bancaria", id: "CertificadoBancario" },
      {
        nombre: "Carta de compriso del trabajador/a",
        id: "CertificadoCartaComp",
      },
      { nombre: "Cotizaciones", id: "CertificadoCotizacio" },
    ];
  };

  const timeoutMethod = (callback, delay) => {
    setTimeout(callback, delay);
  };

  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    const user = JSON.parse(userData);
    const token = sessionStorage.getItem("token");

    setUser(user);
    if (user.rol === "Postulante") {
      window.location.href = "/feedPostulante";
      return; // Ensure the rest of the code is not executed
    }

    const queryParams = new URLSearchParams(window.location.search);
    const queryParamValue = queryParams.get("id_postulacion");

    if (queryParamValue) {
      setSolicitudId(queryParamValue);
      setIsDraft(true);

      try {
        fetchDocument(queryParamValue).then((certificado) => {
          if (certificado) {
            setDocumentosSolicitud(certificado);
          }
        });
      } catch (er) {}

      const fetchData = async () => {
        try {
          const solicitudInfo = await getSolicitudInfoById(
            queryParamValue,
            token
          );
          try {
            const comentariosVar = await getComment(queryParamValue, token);
            setComentarios(comentariosVar);
          } catch (er) {}
          setSolicitudDraft(solicitudInfo);

          if (solicitudInfo.id_proceso) {
            const solicitud = await getSolicitudById(
              solicitudInfo.id_proceso,
              token
            );
            setSolicitud(solicitud);
            calculateDaysRemaining(solicitud.fecha_fin);
          }

          const solicitudRespuestas = await fetchRespuestas(queryParamValue);
          setRespuestas(solicitudRespuestas[0]);
          const solicitudPuntajes = await fetchPuntajes(queryParamValue, token);
          setPuntajes(solicitudPuntajes);

          setRadioSolucion3(solicitudPuntajes.puntaje_problema);
          setRadioSolucion4(solicitudPuntajes.puntaje_beneficiario);
          setRadioSolucion1(solicitudPuntajes.puntaje_solucion);
          setRadioSolucion2(solicitudPuntajes.puntaje_objetivo);
          setRadioSolucion5(solicitudPuntajes.puntaje_actividades);
          setRadioSolucion6(solicitudPuntajes.puntaje_plan_difusion);
          setRadioSolucion7(solicitudPuntajes.puntaje_presupuesto);
          solicitudPuntajes.puntaje_actividad === 5
            ? setChecked(true)
            : setChecked(false);
        } catch (error) {
          console.error(error);
        } finally {
          timeoutMethod(() => {
            setIsLoading(false);
          }, 2000);
          Swal.fire({
            title: "Aviso",
            text: "La revision del formulario debe ser de forma secuencial",
            icon: "warning",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#146abe",
          });
        }
      };

      fetchData();
    } else {
      setIsLoading(false);
      Swal.fire({
        title: "Aviso",
        text: "La revision del formulario debe ser de forma secuencial",
        icon: "warning",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#146abe",
      });
    }
  }, []);

  const calculateDaysRemaining = (fecha_fin) => {
    const fechaObjetivo = new Date(fecha_fin);
    const fechaActual = new Date();
    const diferenciaMilisegundos = fechaObjetivo - fechaActual;
    const diasRestantes = Math.ceil(
      diferenciaMilisegundos / (1000 * 60 * 60 * 24)
    );
    setFecha(diasRestantes);
  };

  const nextStep = () => {
    setAnimating(true);

    setTimeout(() => {
      setCurrentStep(currentStep + 1);
      setTimeout(() => {
        setAnimating(false);
      }, 500); // delay before setting animating to false
    }, 0); // immediate change to currentStep
  };

  const validateAndNext = (values, currentStep) => {
    const errors = validate(values, currentStep);
    if (Object.values(errors).length < 1) {
      nextStep();
    } else {
      let textoError = Object.values(errors).join(",\n");
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          "Por favor completa todos los campos requeridos.\n\n" + textoError,
        confirmButtonText: "Aceptar",
      });
    }
  };

  const prevStep = () => {
    setAnimating(true);
    setTimeout(() => {
      setCurrentStep(currentStep - 1);
      setTimeout(() => {
        setAnimating(false);
      }, 500); // delay before setting animating to false
    }, 0); // immediate change to currentStep
  };

  const handleClick = (step) => {
    if (!animating) {
      //setCurrentStep(step);
    }
  };

  const validate = (values, currentStep) => {
    const errors = {};

    if (currentStep === 5) {
      if (
        radioSolucion1 === null ||
        radioSolucion2 === null ||
        radioSolucion3 === null ||
        radioSolucion4 === null
      ) {
        errors.radios = "Por favor selecciona una opción para cada pregunta";
      }

      const necesitaComentario = Array.from(
        document.getElementsByName("radioSolucion3")
      )
        .slice(0, 3)
        .some((radio) => radio.checked);

      if (necesitaComentario && values.observacion_idef_problema.length < 1) {
        errors.observacion_idef_problema =
          "Comentario de identificación de problema es requerido";
      }

      const necesitaComentario2 = Array.from(
        document.getElementsByName("radioSolucion1")
      )
        .slice(0, 3)
        .some((radio) => radio.checked);

      if (
        necesitaComentario2 &&
        values.observacion_descripcion_proyecto.length < 1
      ) {
        errors.observacion_descripcion_proyecto =
          "Comentario de descripción de proyecto es requerido";
      }

      const necesitaComentario3 = Array.from(
        document.getElementsByName("radioSolucion2")
      )
        .slice(0, 3)
        .some((radio) => radio.checked);

      if (necesitaComentario3 && !values.observacion_objetivos) {
        errors.observacion_objetivos = "Comentario de objetivos es requerido";
      }

      const necesitaComentario4 = Array.from(
        document.getElementsByName("radioSolucion4")
      )
        .slice(0, 3)
        .some((radio) => radio.checked);

      if (necesitaComentario4 && !values.observacion_beneficiarios) {
        errors.observacion_beneficiarios =
          "Comentario de beneficiarios es requerido";
      }

      if (Object.keys(errors).length > 0) {
        setStepValid((prevState) => {
          const newState = [...prevState];
          newState[2] = false;
          return newState;
        });
      } else {
        setStepValid((prevState) => {
          const newState = [...prevState];
          newState[2] = true;
          return newState;
        });
      }
    }

    if (currentStep === 6) {
      if (radioSolucion5 === null || radioSolucion6 === null) {
        errors.radios = "Por favor selecciona una opción para cada pregunta";
      }

      const necesitaComentario5 = Array.from(
        document.getElementsByName("radioSolucion5")
      )
        .slice(0, 3)
        .some((radio) => radio.checked);

      if (necesitaComentario5 && !values.observacion_actividades) {
        errors.observacion_actividades =
          "Comentario de actividades es requerido";
      }

      const necesitaComentario6 = Array.from(
        document.getElementsByName("radioSolucion6")
      )
        .slice(0, 3)
        .some((radio) => radio.checked);

      if (necesitaComentario6 && !values.observacion_plan_difusion) {
        errors.observacion_plan_difusion =
          "Comentario de plan de difusión es requerido";
      }

      if (Object.keys(errors).length > 0) {
        setStepValid((prevState) => {
          const newState = [...prevState];
          newState[3] = false;
          return newState;
        });
      } else {
        setStepValid((prevState) => {
          const newState = [...prevState];
          newState[3] = true;
          return newState;
        });
      }
    }

    if (currentStep === 7) {
      if (radioSolucion7 === null) {
        errors.radios = "Por favor selecciona una opción para cada pregunta";
      }

      const necesitaComentario7 = Array.from(
        document.getElementsByName("radioSolucion7")
      )
        .slice(0, 3)
        .some((radio) => radio.checked);

      if (necesitaComentario7 && !values.observacion_presupuesto) {
        errors.observacion_presupuesto =
          "Comentario de presupuesto es requerido";
      }

      if (Object.keys(errors).length > 0) {
        setStepValid((prevState) => {
          const newState = [...prevState];
          newState[4] = false;
          return newState;
        });
      } else {
        setStepValid((prevState) => {
          const newState = [...prevState];
          newState[4] = true;
          return newState;
        });
      }
    }

    const errorMessages = Object.values(errors);
    return errors;
  };

  const errorMessageStyle = {
    color: "red",
  };

  const [goperacionalesMontoSolicitados, setGoperacionalesMontoSolicitados] =
    useState(Array(5).fill(0));

  const [goperacionalesTotal, setGoperacionalesTotal] = useState(0);

  useEffect(() => {
    var fill = [];

    if (presupuestoGO) {
      for (let i = 0; i < 5; i++) {
        fill.push(presupuestoGO[i]);
      }
    } else {
      fill = [0, 0, 0, 0, 0];
    }

    setGoperacionalesMontoSolicitados(fill);
    var x = calculateTotal(fill);
    setGoperacionalesTotal(x);
  }, [presupuestoGO]);

  const calculateTotal = (montoSolicitados) => {
    const total = montoSolicitados.reduce(
      (acc, monto) => parseInt(acc) + parseInt(monto),
      0
    );
    return total;
  };

  const [infraestructuraMontoSolicitados, setInfraestructuraMontoSolicitados] =
    useState(Array(2).fill(0));

  useEffect(() => {
    var fill = [];
    if (presupuestoInfra) {
      for (let i = 0; i < 2; i++) {
        fill.push(presupuestoInfra[i]);
      }
    } else {
      fill = [0, 0];
    }
    setInfraestructuraMontoSolicitados(fill);
    calculateInfraestructuraTotal(fill);
  }, [presupuestoInfra]);
  const [infraestructuraTotal, setInfraestructuraTotal] = useState(0);

  const handleInfraestructuraMontoSolicitadoChange = (index, event) => {
    const newInfraestructuraMontoSolicitados = [
      ...infraestructuraMontoSolicitados,
    ];
    newInfraestructuraMontoSolicitados[index] = event.target.value;
    setInfraestructuraMontoSolicitados(newInfraestructuraMontoSolicitados);
    calculateInfraestructuraTotal(newInfraestructuraMontoSolicitados);
  };

  const calculateInfraestructuraTotal = (montoSolicitados) => {
    const total = montoSolicitados.reduce(
      (acc, monto) => parseInt(acc) + parseInt(monto),
      0
    );
    setInfraestructuraTotal(total);
  };

  const [recursosHumanosMontoSolicitados, setRecursosHumanosMontoSolicitados] =
    useState(Array(2).fill());
  useEffect(() => {
    var fill = [];
    if (presupuestoHhrr) {
      for (let i = 0; i < 2; i++) {
        fill.push(presupuestoHhrr[i]);
      }
    } else {
      fill = [0, 0];
    }
    setRecursosHumanosMontoSolicitados(fill);

    calculateRecursosHumanosTotal(fill);
  }, [presupuestoHhrr]);

  const [recursosHumanosTotal, setRecursosHumanosTotal] = useState(0);

  const calculateRecursosHumanosTotal = (montoSolicitados) => {
    const total = montoSolicitados.reduce(
      (acc, monto) => parseInt(acc) + parseInt(monto),
      0
    );
    setRecursosHumanosTotal(total);
  };

  const handleRadioChange = (name, value, multiplier) => {
    switch (name) {
      case "radioSolucion1":
        setRadioSolucion1(value * multiplier);
        break;
      case "radioSolucion2":
        setRadioSolucion2(value * multiplier);
        break;
      case "radioSolucion3":
        setRadioSolucion3(value * multiplier);
        break;
      case "radioSolucion4":
        setRadioSolucion4(value * multiplier);
        break;
      case "radioSolucion5":
        setRadioSolucion5(value * multiplier);
        break;
      case "radioSolucion6":
        setRadioSolucion6(value * multiplier);
        break;
      case "radioSolucion7":
        setRadioSolucion7(value * multiplier);
        break;
      default:
        break;
    }
  };

  const calculateTotalPTS = () => {
    let total =
      (radioSolucion1 || 0) +
      (radioSolucion2 || 0) +
      (radioSolucion3 || 0) +
      (radioSolucion4 || 0) +
      (radioSolucion5 || 0) +
      (radioSolucion6 || 0) +
      (radioSolucion7 || 0);

    if (checked) {
      total += 5;
    }

    return total;
  };

  const handleSubmit = async (values) => {
    const puntajes = {
      id_solicitud: parseInt(solicitudId),
      puntaje_problema: radioSolucion3,
      puntaje_beneficiario: radioSolucion4,
      puntaje_solucion: radioSolucion1,
      puntaje_objetivo: radioSolucion2,
      puntaje_actividades: radioSolucion5,
      puntaje_plan_difusion: radioSolucion6,
      puntaje_presupuesto: radioSolucion7,
      puntaje_actividad: checked ? 5 : 0,
    };

    const comentarios = {
      id_solicitud: parseInt(solicitudId),
      observacion_idef_problema: values.observacion_idef_problema || "",
      observacion_beneficiarios: values.observacion_beneficiarios || "",
      observacion_solucion: values.observacion_solucion || "",
      observacion_objetivos: values.observacion_objetivo || "",
      observacion_actividades: values.observacion_actividades || "",
      observacion_plan_difusion: values.observacion_plan_difusion || "",
      observacion_presupuesto: values.observacion_presupuesto || "",
      observacion_descripcion_proyecto:
        values.observacion_descripcion_proyecto || "",
    };

    const token = sessionStorage.getItem("token");
    try {
      Swal.fire({
        title: "Cargando...",
        text: "Por favor, espera un momento mientras se envian los datos...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      await createComment(comentarios, token);
      await evaluarSolicitud(puntajes, token);

      Swal.fire({
        icon: "success",
        title: "Evaluación exitosa",
        text: "La evaluación se ha guardado correctamente",
        confirmButtonText: "Aceptar",
      });

      window.location.href = "/feedEvaluador";
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.detail ??
          "Ocurrió un error al evaluar la solicitud",
        confirmButtonText: "Aceptar",
      });

      console.error("Error al evaluar la solicitud:", error);
    }
  };

  if (isLoading) {
    return <CustomLoading />;
  }

  return (
    <Formik
      initialValues={{
        NombreProyecto: isDraft ? solicitudDraft.nombre_proyecto : "",
        NumBeneficiarios: isDraft ? solicitudDraft.numero_beneficiarios : "",
        radio: isDraft ? solicitudDraft.linea_financiamiento : "",
        AporteSolicitado: isDraft ? solicitudDraft.aporte_solicitado : "",
        observacion_idef_problema: isDraft
          ? comentarios.observacion_idef_problema
          : "",
        observacion_beneficiarios: isDraft
          ? comentarios.observacion_beneficiarios
          : "",
        observacion_solucion: isDraft ? comentarios.observacion_solucion : "",
        observacion_objetivos: isDraft ? comentarios.observacion_objetivo : "",
        observacion_actividades: isDraft
          ? comentarios.observacion_actividades
          : "",
        observacion_plan_difusion: isDraft
          ? comentarios.observacion_plan_difusion
          : "",
        observacion_presupuesto: isDraft
          ? comentarios.observacion_presupuesto
          : "",
        observacion_descripcion_proyecto: isDraft
          ? comentarios.observacion_descripcion_proyecto
          : "",
        NombreOrg: isDraft ? solicitudDraft.nombre_organizacion : "",
        RUTOrg: isDraft ? solicitudDraft.rut_organizacion : "",
        DirOrg: isDraft ? solicitudDraft.direccion_org : "",
        NombreRepLegal: isDraft
          ? solicitudDraft.nombre_representante_legal
          : "",
        RUTRepLegal: isDraft ? solicitudDraft.rut_representante_legal : "",
        DirRepLegal: isDraft ? solicitudDraft.direccion_rep_legal : "",
        TelRepLegal: isDraft ? solicitudDraft.telefono_rep_legal : "",
        CorreoRepLegal: isDraft ? solicitudDraft.correo_rep_legal : "",
        NombreRespProyecto: isDraft
          ? solicitudDraft.nombre_responsable_proy
          : "",
        RUTRespProyecto: isDraft ? solicitudDraft.rut_responsable_proy : "",
        DirRespProyecto: isDraft
          ? solicitudDraft.direccion_responsable_proy
          : "",
        TelRespProyecto: isDraft
          ? solicitudDraft.telefono_responsable_proy
          : "",
        CorreoRespProyecto: isDraft
          ? solicitudDraft.correo_responsable_proy
          : "",

        IdProblema: isDraft ? respuestas.identificacion_problema : "",
        Beneficiarios: isDraft ? respuestas.beneficiarios : "",
        DesProyecto: isDraft ? respuestas.descripcion_proyecto : "",
        ObjetivoGeneral: isDraft ? respuestas.objetivo_general : "",
        ObjetivoEspec1: isDraft ? respuestas.objetivo_especifico_1 : "",
        ObjetivoEspec2: isDraft ? respuestas.objetivo_especifico_2 : "",
        ObjetivoEspec3: isDraft ? respuestas.objetivo_especifico_3 : "",

        ActividadesNombre_0: isDraft ? respuestas.nombre_actividad_0 : "",
        ActividadesDescripcion_0: isDraft
          ? respuestas.descripcion_actividad_0
          : "",
        ActividadesNombre_1: isDraft ? respuestas.nombre_actividad_1 : "",
        ActividadesDescripcion_1: isDraft
          ? respuestas.descripcion_actividad_1
          : "",
        ActividadesNombre_2: isDraft ? respuestas.nombre_actividad_2 : "",
        ActividadesDescripcion_2: isDraft
          ? respuestas.descripcion_actividad_2
          : "",
        ActividadesNombre_3: isDraft ? respuestas.nombre_actividad_3 : "",
        ActividadesDescripcion_3: isDraft
          ? respuestas.descripcion_actividad_3
          : "",
        ActividadesNombre_4: isDraft ? respuestas.nombre_actividad_4 : "",
        ActividadesDescripcion_4: isDraft
          ? respuestas.descripcion_actividad_4
          : "",
        PlanDifusion: isDraft ? solicitudDraft.plan_difusion : "",

        GoperacionalesItem_0: isDraft
          ? solicitudDraft.gasto_operacional_item_0
          : "",
        GoperacionalesUtilizacion_0: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_0
          : "",
        GoperacionalesMontoSolicitado_0: isDraft
          ? solicitudDraft.gasto_operacional_monto_0
          : "",
        GoperacionalesItem_1: isDraft
          ? solicitudDraft.gasto_operacional_item_1
          : "",
        GoperacionalesUtilizacion_1: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_1
          : "",
        GoperacionalesMontoSolicitado_1: isDraft
          ? solicitudDraft.gasto_operacional_monto_1
          : "",
        GoperacionalesItem_2: isDraft
          ? solicitudDraft.gasto_operacional_item_2
          : "",
        GoperacionalesUtilizacion_2: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_2
          : "",
        GoperacionalesMontoSolicitado_2: isDraft
          ? solicitudDraft.gasto_operacional_monto_2
          : "",
        GoperacionalesItem_3: isDraft
          ? solicitudDraft.gasto_operacional_item_3
          : "",
        GoperacionalesUtilizacion_3: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_3
          : "",
        GoperacionalesMontoSolicitado_3: isDraft
          ? solicitudDraft.gasto_operacional_monto_3
          : "",
        GoperacionalesExtraTotal:
          parseInt(solicitudDraft.gasto_operacional_monto_0) +
          parseInt(solicitudDraft.gasto_operacional_monto_1) +
          parseInt(solicitudDraft.gasto_operacional_monto_2) +
          parseInt(solicitudDraft.gasto_operacional_monto_3) +
          parseInt(solicitudDraft.gasto_operacional_monto_4) +
          parseInt(solicitudDraft.gasto_operacional_monto_5) +
          parseInt(solicitudDraft.gasto_operacional_monto_6) +
          parseInt(solicitudDraft.gasto_operacional_monto_7) +
          parseInt(solicitudDraft.gasto_operacional_monto_8) +
          parseInt(solicitudDraft.gasto_operacional_monto_9),

        GoperacionalesItem_4: isDraft
          ? solicitudDraft.gasto_operacional_item_4
          : "",
        GoperacionalesUtilizacion_4: isDraft
          ? solicitudDraft.gasto_operacional_utilizacion_4
          : "",
        GoperacionalesMontoSolicitado_4: isDraft
          ? solicitudDraft.gasto_operacional_monto_4
          : "",
        InfraestructuraItem_0: isDraft ? solicitudDraft.infra_item_0 : "",
        InfraestructuraUtilizacion_0: isDraft
          ? solicitudDraft.infra_utilizacion_0
          : "",
        InfraestructuraMontoSolicitado_0: isDraft
          ? solicitudDraft.infra_monto_0
          : "",
        InfraestructuraItem_1: isDraft ? solicitudDraft.infra_item_1 : "",
        InfraestructuraUtilizacion_1: isDraft
          ? solicitudDraft.infra_utilizacion_1
          : "",
        InfraestructuraMontoSolicitado_1: isDraft
          ? solicitudDraft.infra_monto_1
          : "",
        InfraestructuraExtraTotal:
          parseInt(solicitudDraft.infra_monto_0) +
          parseInt(solicitudDraft.infra_monto_1) +
          parseInt(solicitudDraft.infra_monto_2) +
          parseInt(solicitudDraft.infra_monto_3) +
          parseInt(solicitudDraft.infra_monto_4),

        RecursosHumanosItem_0: isDraft ? solicitudDraft.rrhh_item_0 : "",
        RecursosHumanosUtilizacion_0: isDraft
          ? solicitudDraft.rrhh_utilizacion_0
          : "",
        RecursosHumanosMontoSolicitado_0: isDraft
          ? solicitudDraft.rrhh_monto_0
          : "",
        RecursosHumanosItem_1: isDraft ? solicitudDraft.rrhh_item_1 : "",
        RecursosHumanosUtilizacion_1: isDraft
          ? solicitudDraft.rrhh_utilizacion_1
          : "",
        RecursosHumanosMontoSolicitado_1: isDraft
          ? solicitudDraft.rrhh_monto_1
          : "",
        RecursosHumanosExtraTotal:
          parseInt(solicitudDraft.rrhh_monto_0) +
          (parseInt(solicitudDraft.rrhh_monto_1 ?? "0") ?? 0) +
          (parseInt(solicitudDraft.rrhh_monto_2 ?? "0") ?? 0) +
          (parseInt(solicitudDraft.rrhh_monto_3 ?? "0") ?? 0) +
          (parseInt(solicitudDraft.rrhh_monto_4 ?? "0") ?? 0),
      }}
      validate={(values) => validate(values, currentStep)}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, values }) => (
        <DivContenedorMax>
          <DivNavbar>
            <Navbar name={user.nombre_usuario} />
          </DivNavbar>
          <Div>
            <ProgressBar>
              <StepProgress>
                <Step className={`${currentStep >= 0 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 0).toString()}
                    onClick={() => handleClick(0)}
                  >
                    <span>1</span>
                  </Bullet>
                </Step>

                <Step className={`${currentStep >= 1 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 1).toString()}
                    onClick={() => handleClick(1)}
                  >
                    <span>2</span>
                  </Bullet>
                </Step>

                <Step className={`${currentStep >= 2 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 2).toString()}
                    onClick={() => handleClick(2)}
                  >
                    <span>3</span>
                  </Bullet>
                </Step>
                <Step>
                  <Bullet
                    active={(currentStep >= 3).toString()}
                    onClick={() => handleClick(3)}
                  >
                    <span>4</span>
                  </Bullet>
                </Step>

                <Step>
                  <Bullet
                    active={(currentStep >= 4).toString()}
                    onClick={() => handleClick(4)}
                  >
                    <span>5</span>
                  </Bullet>
                </Step>
                <Step className={`${currentStep >= 5 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 5).toString()}
                    onClick={() => handleClick(5)}
                  >
                    <span>6</span>
                  </Bullet>
                  {stepValid[5] &&
                  radioSolucion1 !== null &&
                  radioSolucion2 !== null &&
                  radioSolucion3 !== null &&
                  radioSolucion4 !== null ? (
                    <CheckIcon />
                  ) : (
                    <CloseIcon />
                  )}
                </Step>

                <Step className={`${currentStep >= 6 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 6).toString()}
                    onClick={() => handleClick(6)}
                  >
                    <span>7</span>
                  </Bullet>
                  {stepValid[6] &&
                  radioSolucion5 !== null &&
                  radioSolucion6 !== null ? (
                    <CheckIcon />
                  ) : (
                    <CloseIcon />
                  )}
                </Step>

                <Step className={`${currentStep >= 7 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 7).toString()}
                    onClick={() => handleClick(7)}
                  >
                    <span>8</span>
                  </Bullet>
                  {stepValid[7] && radioSolucion7 !== null ? (
                    <CheckIcon />
                  ) : (
                    <CloseIcon />
                  )}
                </Step>

                <Step className={`${currentStep >= 8 ? "active" : ""}`}>
                  <Bullet
                    active={(currentStep >= 8).toString()}
                    onClick={() => handleClick(8)}
                  >
                    <span>9</span>
                  </Bullet>
                </Step>
              </StepProgress>
            </ProgressBar>
            <SaveIcon>Puntaje obtenido: {calculateTotalPTS()}</SaveIcon>
            <DivForm>
              {isLoading ? (
                <Skeleton width="100%" height={200} />
              ) : (
                <Form>
                  {currentStep === 0 && (
                    <div>
                      <br />
                      <h2>Resumen</h2>
                      <TextInput
                        disabled
                        name="NombreProyecto"
                        label="Nombre Proyecto"
                        readOnly
                      />
                      <br />
                      <NumberInput
                        disabled
                        name="NumBeneficiarios"
                        max={2}
                        label="Número de beneficiarios directos del proyecto"
                        readOnly
                      />
                      <br />
                      <Label>
                        ¿Cuál es la línea de financiamiento a la que postula con
                        este proyecto?:
                      </Label>

                      <RadioInput
                        disabled
                        name="radio"
                        value="Bienestar Físico, Deporte y Recreación"
                        label="Bienestar Físico, Deporte y Recreación"
                      />
                      <RadioInput
                        disabled
                        name="radio"
                        value="Bienestar Psicosocial"
                        label="Bienestar Psicosocial"
                      />
                      <RadioInput
                        disabled
                        name="radio"
                        value="Formación y Capacitación"
                        label="Formación y Capacitación"
                      />
                      <RadioInput
                        disabled
                        name="radio"
                        value="Protección y cuidado del medio ambiente"
                        label="Protección y cuidado del medio ambiente"
                      />
                      <RadioInput
                        disabled
                        name="radio"
                        value="Educación y Artes"
                        label="Educación y Artes"
                      />
                      <RadioInput
                        disabled
                        name="radio"
                        value="Cultura e Identidad Local"
                        label="Cultura e Identidad Local"
                      />
                      <RadioInput
                        disabled
                        name="radio"
                        value="Infraestructura Comunitaria e Insumos"
                        label="Infraestructura Comunitaria e Insumos"
                      />
                      <ErrorMessage
                        disabled
                        name="radio"
                        component="div"
                        style={errorMessageStyle}
                      />
                      <br />
                      <NumberInput
                        disabled
                        name="AporteSolicitado"
                        showPrefix={true}
                        label="Aporte Solicitado"
                        readOnly
                      />
                    </div>
                  )}
                  {currentStep === 1 && (
                    <div>
                      <br />
                      <h2>Org. Postulante</h2>
                      <TextInput
                        disabled
                        name="NombreOrg"
                        label="Nombre de la Organización"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="RUTOrg"
                        label="R.U.T de la organización"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="DirOrg"
                        label="Dirección de la organización"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="tipo_organizacion_nombre"
                        value={solicitudDraft.tipo_organizacion?.nombre ?? ""}
                        label="Tipo de organización"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="sector_nombre"
                        value={solicitudDraft.sector?.nombre ?? ""}
                        label="Sector"
                        readOnly
                      />
                      <br />
                    </div>
                  )}
                  {currentStep === 2 && (
                    <div>
                      <br />
                      <h2>Representante legal </h2>
                      <TextInput
                        disabled
                        name="NombreRepLegal"
                        label="Nombre del/la representante legal"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="RUTRepLegal"
                        label="R.U.T del/la representante legal"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="DirRepLegal"
                        label="Dirección del/la representante legal"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="TelRepLegal"
                        label="Teléfono del/la representante legal"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="CorreoRepLegal"
                        label="Correo electrónico del/la representante legal"
                        readOnly
                      />
                    </div>
                  )}
                  {currentStep === 3 && (
                    <div>
                      <br />
                      <h2>Responsable del Proyecto</h2>
                      <TextInput
                        disabled
                        name="NombreRespProyecto"
                        label="Nombre del/la Responsable del Proyecto"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="RUTRespProyecto"
                        label="R.U.T del/la responsable del proyecto"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="DirRespProyecto"
                        label="Dirección del/la responsable del proyecto"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="TelRespProyecto"
                        label="Teléfono del/la responsable del proyecto"
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="CorreoRespProyecto"
                        label="Correo electrónico del/la representante del proyecto"
                        readOnly
                      />
                    </div>
                  )}

                  {currentStep === 4 && (
                    <div>
                      <br />
                      <h2>Datos Bancarios</h2>
                      <TextInput
                        disabled
                        name="banco_nombre"
                        label="Banco"
                        value={solicitudDraft.banco?.nombre ?? ""}
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="cuenta_tipo"
                        label="Tipo de cuenta"
                        value={solicitudDraft.cuenta_tipo ?? ""}
                        readOnly
                      />
                      <br />
                      <TextInput
                        disabled
                        name="cuenta_numero"
                        label="Numero de cuenta"
                        value={solicitudDraft.cuenta_numero ?? ""}
                        readOnly
                      />
                      <br />
                    </div>
                  )}
                  {currentStep === 5 && (
                    <DivFlex2 className={animating ? "fade" : ""}>
                      <FormSection>
                        <h2>Problema</h2>
                        <FormLabel>
                          <h3>
                            Identificación del problema y justificación del
                            proyecto
                          </h3>{" "}
                        </FormLabel>
                        <TextArea2
                          disabled
                          name="IdProblema"
                          value={values.IdProblema}
                          readOnly
                        />
                        <FormLabel>
                          Puntaje Identificación del Problema: (20Pts)
                          <WarningIcon>⚠️</WarningIcon>
                        </FormLabel>
                        <RadioGroup
                          onChange={(e) => {
                            var comentario = document.getElementById(
                              "comentario_idenfificacion"
                            );
                            comentario.style.display = "block";
                          }}
                        >
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion3"
                              value="0"
                              checked={radioSolucion3 === 0 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion3", 0, 20)
                              }
                            />
                            MALO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion3"
                              value="0.3"
                              checked={radioSolucion3 === 0.3 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion3", 0.3, 20)
                              }
                            />
                            INSUFICIENTE
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion3"
                              value="0.5"
                              checked={radioSolucion3 === 0.5 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion3", 0.5, 20)
                              }
                            />
                            BUENO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion3"
                              value="0.7"
                              checked={radioSolucion3 === 0.7 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion3", 0.7, 20)
                              }
                            />
                            MUY BUENO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion3"
                              value="1"
                              checked={radioSolucion3 === 1 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion3", 1, 20)
                              }
                            />
                            EXCELENTE
                          </LabelRadio>
                        </RadioGroup>
                        <br />
                        <div id="comentario_idenfificacion">
                          <FormLabel>
                            Comentario identificación del problema
                          </FormLabel>
                          <TextComment name="observacion_idef_problema"></TextComment>
                        </div>
                        <FormLabel>
                          <h3>Beneficiarios y beneficiarias</h3>
                        </FormLabel>
                        <TextArea2
                          disabled
                          name="Beneficiarios"
                          value={values.Beneficiarios}
                          readOnly
                        />
                        <FormLabel>
                          Puntaje Beneficiarios: (15Pts)
                          <WarningIcon>⚠️</WarningIcon>
                        </FormLabel>
                        <RadioGroup
                          onChange={(e) => {
                            var comentario = document.getElementById(
                              "comentario_beneficiario"
                            );
                            comentario.style.display = "block";
                          }}
                        >
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion4"
                              value="0"
                              checked={radioSolucion4 === 0 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion4", 0, 15)
                              }
                            />
                            MALO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion4"
                              value="0.3"
                              checked={radioSolucion4 === 0.3 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion4", 0.3, 15)
                              }
                            />
                            INSUFICIENTE
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion4"
                              value="0.5"
                              checked={radioSolucion4 === 0.5 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion4", 0.5, 15)
                              }
                            />
                            BUENO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion4"
                              value="0.7"
                              checked={radioSolucion4 === 0.7 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion4", 0.7, 15)
                              }
                            />
                            MUY BUENO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion4"
                              value="1"
                              checked={radioSolucion4 === 1 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion4", 1, 15)
                              }
                            />
                            EXCELENTE
                          </LabelRadio>
                        </RadioGroup>
                        <br />
                        <div id="comentario_beneficiario">
                          <FormLabel>
                            <h3>Comentario Beneficiarios y Beneficiarias</h3>
                          </FormLabel>
                          <TextComment name="observacion_beneficiarios"></TextComment>
                        </div>
                      </FormSection>
                      <FormSection>
                        <h2>Solución</h2>
                        <FormLabel>
                          <h3>Descripción general del proyecto</h3>
                        </FormLabel>
                        <TextArea2
                          disabled
                          name="DesProyecto"
                          value={values.DesProyecto}
                          readOnly
                        />
                        <FormLabel>
                          Propuesta de solución: (20Pts)
                          <WarningIcon>⚠️</WarningIcon>
                        </FormLabel>
                        <RadioGroup
                          onChange={(e) => {
                            var comentario = document.getElementById(
                              "comentario_descripcion"
                            );
                            comentario.style.display = "block";
                          }}
                        >
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion1"
                              value="0"
                              checked={radioSolucion1 === 0 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion1", 0, 20)
                              }
                            />
                            MALO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion1"
                              value="0.3"
                              checked={radioSolucion1 === 0.3 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion1", 0.3, 20)
                              }
                            />
                            INSUFICIENTE
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion1"
                              value="0.5"
                              checked={radioSolucion1 === 0.5 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion1", 0.5, 20)
                              }
                            />
                            BUENO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion1"
                              value="0.7"
                              checked={radioSolucion1 === 0.7 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion1", 0.7, 20)
                              }
                            />
                            MUY BUENO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion1"
                              value="1"
                              checked={radioSolucion1 === 1 * 20}
                              onChange={() =>
                                handleRadioChange("radioSolucion1", 1, 20)
                              }
                            />
                            EXCELENTE
                          </LabelRadio>
                        </RadioGroup>
                        <br />
                        <div id="comentario_descripcion">
                          <FormLabel>
                            <h3>Comentario descripción del proyecto</h3>
                          </FormLabel>
                          <TextComment name="observacion_descripcion_proyecto"></TextComment>
                        </div>
                        <FormLabel>Objetivo General</FormLabel>
                        <TextArea2
                          disabled
                          name="ObjetivoGeneral"
                          value={values.ObjetivoGeneral}
                          readOnly
                        />
                        <FormLabel>Objetivo Específico 1</FormLabel>
                        <TextArea2
                          disabled
                          name="ObjetivoEspec1"
                          value={values.ObjetivoEspec1}
                          readOnly
                        />
                        <FormLabel>Objetivo Específico 2</FormLabel>
                        <TextArea2
                          disabled
                          name="ObjetivoEspec2"
                          value={values.ObjetivoEspec2}
                          readOnly
                        />
                        <FormLabel>Objetivo Específico 3</FormLabel>
                        <TextArea2
                          disabled
                          name="ObjetivoEspec3"
                          value={values.ObjetivoEspec3}
                          readOnly
                        />
                        <FormLabel>
                          Objetivos: (15Pts)<WarningIcon>⚠️</WarningIcon>
                        </FormLabel>
                        <RadioGroup
                          onChange={(e) => {
                            var comentario = document.getElementById(
                              "comentario_objetivo"
                            );
                            comentario.style.display = "block";
                          }}
                        >
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion2"
                              value="0"
                              checked={radioSolucion2 === 0 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion2", 0, 15)
                              }
                            />
                            MALO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion2"
                              value="0.3"
                              checked={radioSolucion2 === 0.3 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion2", 0.3, 15)
                              }
                            />
                            INSUFICIENTE
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion2"
                              value="0.5"
                              checked={radioSolucion2 === 0.5 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion2", 0.5, 15)
                              }
                            />
                            BUENO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion2"
                              value="0.7"
                              checked={radioSolucion2 === 0.7 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion2", 0.7, 15)
                              }
                            />
                            MUY BUENO
                          </LabelRadio>
                          <LabelRadio>
                            <RadioInput2
                              type="radio"
                              name="radioSolucion2"
                              value="1"
                              checked={radioSolucion2 === 1 * 15}
                              onChange={() =>
                                handleRadioChange("radioSolucion2", 1, 15)
                              }
                            />
                            EXCELENTE
                          </LabelRadio>
                        </RadioGroup>

                        <div id="comentario_objetivo">
                          <FormLabel>Comentario objetivo</FormLabel>
                          <TextComment name="observacion_objetivos"></TextComment>
                        </div>
                      </FormSection>
                    </DivFlex2>
                  )}
                  {currentStep === 6 && (
                    <DivFlex3 className={animating ? "fade" : ""}>
                      <FormSection3>
                        <h2>Planificación</h2>
                        <FormLabel3>
                          <h3>Actividades del Proyecto:</h3>
                        </FormLabel3>
                        <Table3>
                          <thead>
                            <tr>
                              <th>Nombre de la Actividad</th>
                              <th>Descripción</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.from({ length: 5 }).map((_, index) => (
                              <tr key={index}>
                                <td>
                                  <FieldPresupuesto
                                    disabled
                                    name={`ActividadesNombre_${index}`}
                                    value={values[`ActividadesNombre_${index}`]}
                                    placeholder="Nombre de la actividad"
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <FieldPresupuesto
                                    disabled
                                    name={`ActividadesDescripcion_${index}`}
                                    value={
                                      values[`ActividadesDescripcion_${index}`]
                                    }
                                    placeholder="Descripción"
                                    readOnly
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table3>
                        <FormLabel3>
                          Actividades: (10Pts)<WarningIcon>⚠️</WarningIcon>
                        </FormLabel3>
                        <RadioGroup3
                          onChange={(e) => {
                            var comentario = document.getElementById(
                              "comentario_actividades"
                            );
                            comentario.style.display = "block";
                          }}
                        >
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion5"
                              value="0"
                              checked={radioSolucion5 === 0 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion5", 0, 10)
                              }
                            />
                            <span>MALO</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion5"
                              value="0.3"
                              checked={radioSolucion5 === 0.3 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion5", 0.3, 10)
                              }
                            />
                            <span>INSUFICIENTE</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion5"
                              value="0.5"
                              checked={radioSolucion5 === 0.5 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion5", 0.5, 10)
                              }
                            />
                            <span>BUENO</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion5"
                              value="0.7"
                              checked={radioSolucion5 === 0.7 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion5", 0.7, 10)
                              }
                            />
                            <span>MUY BUENO</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion5"
                              value="1"
                              checked={radioSolucion5 === 1 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion5", 1, 10)
                              }
                            />
                            <span>EXCELENTE</span>
                          </RadioInputWrapper>
                        </RadioGroup3>
                        <div id="comentario_actividades">
                          <FormLabel>Comentario actividades</FormLabel>
                          <TextComment name="observacion_actividades"></TextComment>
                        </div>
                        <FormLabel3>
                          <h3>Plan de difusión</h3>
                        </FormLabel3>
                        <TextArea2
                          value={values.PlanDifusion}
                          disabled
                          name="PlanDifusion"
                        />
                        <FormLabel3>
                          Propuesta de difusión (5Pts)
                          <WarningIcon>⚠️</WarningIcon>
                        </FormLabel3>
                        <RadioGroup3
                          onChange={(e) => {
                            var comentario = document.getElementById(
                              "comentario_difusion"
                            );
                            comentario.style.display = "block";
                          }}
                        >
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion6"
                              value="0"
                              checked={radioSolucion6 === 0 * 5}
                              onChange={() =>
                                handleRadioChange("radioSolucion6", 0, 5)
                              }
                            />
                            <span>MALO</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion6"
                              value="0.3"
                              checked={radioSolucion6 === 0.3 * 5}
                              onChange={() =>
                                handleRadioChange("radioSolucion6", 0.3, 5)
                              }
                            />
                            <span>INSUFICIENTE</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion6"
                              value="0.5"
                              checked={radioSolucion6 === 0.5 * 5}
                              onChange={() =>
                                handleRadioChange("radioSolucion6", 0.5, 5)
                              }
                            />
                            <span>BUENO</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion6"
                              value="0.7"
                              checked={radioSolucion6 === 0.7 * 5}
                              onChange={() =>
                                handleRadioChange("radioSolucion6", 0.7, 5)
                              }
                            />
                            <span>MUY BUENO</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput3
                              type="radio"
                              name="radioSolucion6"
                              value="1"
                              checked={radioSolucion6 === 1 * 5}
                              onChange={() =>
                                handleRadioChange("radioSolucion6", 1, 5)
                              }
                            />
                            <span>EXCELENTE</span>
                          </RadioInputWrapper>
                        </RadioGroup3>
                        <div id="comentario_difusion">
                          <FormLabel>
                            Comentario propuesta de difusión
                          </FormLabel>
                          <TextComment name="observacion_plan_difusion"></TextComment>
                        </div>
                      </FormSection3>
                    </DivFlex3>
                  )}
                  {currentStep === 7 && (
                    <DivFlex className={animating ? "fade" : ""}>
                      <FormSection>
                        <br />
                        <h2>Presupuesto</h2>
                        <FormLabel>
                          <h3>Gastos Operacionales:</h3>
                        </FormLabel>
                        <Table>
                          <thead>
                            <tr>
                              <th>Item</th>
                              <th>Utilización</th>
                              <th>Monto solicitado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.from({ length: 10 }).map((_, index) => (
                              <tr
                                key={index}
                                style={{
                                  display: solicitudDraft[
                                    `gasto_operacional_monto_${index}`
                                  ]
                                    ? "table-row"
                                    : "none",
                                }}
                              >
                                <td>
                                  <FieldPresupuesto
                                    disabled
                                    name="fake-field"
                                    value={
                                      solicitudDraft[
                                        `gasto_operacional_item_${index}`
                                      ]
                                    }
                                    placeholder="Item"
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <FieldPresupuesto
                                    disabled
                                    name="fake-field"
                                    value={
                                      solicitudDraft[
                                        `gasto_operacional_utilizacion_${index}`
                                      ]
                                    }
                                    placeholder="Utilización"
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <FieldP5
                                    disabled
                                    name={`fake-field`}
                                    placeholder="Monto solicitado"
                                    type="number"
                                    showPrefix={true}
                                    width={100}
                                    value={
                                      solicitudDraft[
                                        `gasto_operacional_monto_${index}`
                                      ]
                                    }
                                    readOnly
                                  />
                                </td>
                              </tr>
                            ))}
                            <tr key={4}>
                              <td></td>
                              <td></td>
                              <td>
                                <FieldP5
                                  disabled
                                  name={`GoperacionalesExtraTotal`}
                                  value={values.GoperacionalesExtraTotal}
                                  type="number"
                                  showPrefix={true}
                                  readOnly
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>

                        <FormLabel>
                          <h3>Infraestructura:</h3>
                        </FormLabel>
                        <Table>
                          <thead>
                            <tr>
                              <th>Item</th>
                              <th>Utilización</th>
                              <th>Monto solicitado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.from({ length: 5 }).map((_, index) => (
                              <tr
                                key={index}
                                style={{
                                  display: solicitudDraft[
                                    `infra_monto_${index}`
                                  ]
                                    ? "table-row"
                                    : "none",
                                }}
                              >
                                <td>
                                  <FieldPresupuesto
                                    disabled
                                    name="fake-field"
                                    value={
                                      solicitudDraft[`infra_item_${index}`]
                                    }
                                    placeholder="Item"
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <FieldPresupuesto
                                    disabled
                                    name="fake-field"
                                    value={
                                      solicitudDraft[
                                        `infra_utilizacion_${index}`
                                      ]
                                    }
                                    placeholder="Utilización"
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <FieldP5
                                    disabled
                                    name="fake-field"
                                    placeholder="Monto solicitado"
                                    type="number"
                                    showPrefix={true}
                                    value={
                                      solicitudDraft[`infra_monto_${index}`]
                                    }
                                    readOnly
                                  />
                                </td>
                              </tr>
                            ))}
                            <tr key={4}>
                              <td></td>
                              <td></td>
                              <td>
                                <FieldP5
                                  disabled
                                  name="fake-field"
                                  placeholder="TOTAL"
                                  type="number"
                                  showPrefix={true}
                                  readOnly
                                  value={values.InfraestructuraExtraTotal}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>

                        <FormLabel>
                          <h3>Recursos Humanos:</h3>
                        </FormLabel>
                        <Table>
                          <thead>
                            <tr>
                              <th>Item</th>
                              <th>Utilización</th>
                              <th>Monto solicitado</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.from({ length: 5 }).map((_, index) => (
                              <tr
                                key={index}
                                style={{
                                  display: solicitudDraft[`rrhh_monto_${index}`]
                                    ? "table-row"
                                    : "none",
                                }}
                              >
                                <td>
                                  <FieldPresupuesto
                                    disabled
                                    name="fake-field"
                                    value={solicitudDraft[`rrhh_item_${index}`]}
                                    placeholder="Item"
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <FieldPresupuesto
                                    disabled
                                    name="fake-field"
                                    value={
                                      solicitudDraft[
                                        `rrhh_utilizacion_${index}`
                                      ]
                                    }
                                    placeholder="Utilización"
                                    readOnly
                                  />
                                </td>
                                <td>
                                  <FieldP5
                                    disabled
                                    name="fake-field"
                                    placeholder="Monto solicitado"
                                    type="number"
                                    showPrefix={true}
                                    value={
                                      solicitudDraft[`rrhh_monto_${index}`]
                                    }
                                    readOnly
                                  />
                                </td>
                              </tr>
                            ))}
                            <tr key={4}>
                              <td></td>
                              <td></td>
                              <td>
                                <FieldP5
                                  disabled
                                  name="fake-field"
                                  placeholder="TOTAL"
                                  readOnly
                                  type="number"
                                  showPrefix={true}
                                  value={values.RecursosHumanosExtraTotal}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <ErrorMessage
                          name={`RecursosHumanosItem_0`}
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name={`RecursosHumanosUtilizacion_0`}
                          component="div"
                          style={{ color: "red" }}
                        />
                        <ErrorMessage
                          name={`RecursosHumanosMontoSolicitado_0`}
                          component="div"
                          style={{ color: "red" }}
                        />

                        <FormLabel>
                          Presupuesto: (10Pts)<WarningIcon>⚠️</WarningIcon>
                        </FormLabel>
                        <RadioGroup
                          onChange={(e) => {
                            var comentario = document.getElementById(
                              "comentario_presupuesto"
                            );
                            comentario.style.display = "block";
                          }}
                        >
                          <RadioInputWrapper>
                            <RadioInput
                              type="radio"
                              name="radioSolucion7"
                              value="0"
                              checked={radioSolucion7 === 0 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion7", 0, 10)
                              }
                            />
                            <span>MALO</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput
                              type="radio"
                              name="radioSolucion7"
                              value="0.3"
                              checked={radioSolucion7 === 0.3 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion7", 0.3, 10)
                              }
                            />
                            <span>INSUFICIENTE</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput
                              type="radio"
                              name="radioSolucion7"
                              value="0.5"
                              checked={radioSolucion7 === 0.5 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion7", 0.5, 10)
                              }
                            />
                            <span>BUENO</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput
                              type="radio"
                              name="radioSolucion7"
                              value="0.7"
                              checked={radioSolucion7 === 0.7 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion7", 0.7, 10)
                              }
                            />
                            <span>MUY BUENO</span>
                          </RadioInputWrapper>
                          <RadioInputWrapper>
                            <RadioInput
                              type="radio"
                              name="radioSolucion7"
                              value="1"
                              checked={radioSolucion7 === 1 * 10}
                              onChange={() =>
                                handleRadioChange("radioSolucion7", 1, 10)
                              }
                            />
                            <span>EXCELENTE</span>
                          </RadioInputWrapper>
                        </RadioGroup>
                        <div id="comentario_presupuesto">
                          <FormLabel>Comentario presupuesto</FormLabel>
                          <TextComment name="observacion_presupuesto"></TextComment>
                        </div>
                      </FormSection>
                    </DivFlex>
                  )}
                  {currentStep === 8 && (
                    <DivFlex className={animating ? "fade" : ""}>
                      <div style={{ width: "100%" }}>
                        <br />
                        <br />
                        <h2>Adjuntos</h2>

                        {getCategoriasDocumentos().map((c) => (
                          <div
                            style={{
                              borderBottom: "1px solid #bbbbbb",
                              paddingBottom: "12px",
                              marginBottom: "4px",
                            }}
                          >
                            <h5>{c.nombre}</h5>

                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "start",
                              }}
                            >
                              {documentosSolicitud
                                .filter((i) => i.categoria === c.id)
                                .map((doc, index) => (
                                  <DocumentItem documento={doc}></DocumentItem>
                                ))}
                            </div>
                          </div>
                        ))}
                        <br />
                        <div style={{ textAlign: "center" }}>
                          <Checkbox
                            onChange={(e) => setChecked(e.target.checked)}
                            checked={checked}
                          ></Checkbox>
                          <label className="ml-2">
                            {" "}
                            Asiste a la actividad presencial convocada por
                            Colbun.(5Pts)
                            <WarningIcon />
                          </label>
                        </div>
                      </div>
                    </DivFlex>
                  )}
                  <br />
                  <DivButtons>
                    <div>
                      {currentStep !== 0 && (
                        <ButtonAtras
                          type="button"
                          onClick={() => {
                            validate(values, currentStep);
                            prevStep();
                          }}
                          disabled={currentStep === 0}
                        >
                          Anterior
                        </ButtonAtras>
                      )}
                    </div>

                    <div>
                      {currentStep === 8 ? (
                        <div>
                          <ButtonEnviar
                            type="submit"
                            disabled={
                              radioSolucion1 == null ||
                              radioSolucion2 == null ||
                              radioSolucion3 == null ||
                              radioSolucion4 == null ||
                              radioSolucion5 == null ||
                              radioSolucion6 == null ||
                              radioSolucion7 == null ||
                              stepValid[2] === false ||
                              stepValid[3] === false ||
                              stepValid[4] === false
                            }
                          >
                            Guardar
                          </ButtonEnviar>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div>
                      {currentStep !== 8 && (
                        <ButtonNext
                          type="button"
                          onClick={() => {
                            validateAndNext(values, currentStep);
                          }}
                          disabled={currentStep === 8}
                        >
                          Siguiente
                        </ButtonNext>
                      )}
                    </div>
                  </DivButtons>
                  <DivContenedorError>
                    {errores && errores.length > 0 && (
                      <DivError>
                        <p>
                          Error de envío, revisa el ingreso de tus datos:{" "}
                          {errores.join(", ")}
                        </p>
                      </DivError>
                    )}
                  </DivContenedorError>
                </Form>
              )}
            </DivForm>
          </Div>
        </DivContenedorMax>
      )}
    </Formik>
  );
};

export default MultiStepFormRevision;
